import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const IST = "Asia/Kolkata";

const ROUTE_STATUS_LABELS = {
  in_progress: "IN Progress",
  completed: "Completed",
  expired: "Expired",
  planned: "Planned",
};

/**
 * Format API timestamps (usually UTC ISO) for display in IST.
 */
export function formatDateTimeIST(raw) {
  if (raw == null || raw === "") return "";
  const d = dayjs(raw);
  if (!d.isValid()) return String(raw);
  return d.tz(IST).format("YYYY-MM-DD HH:mm:ss");
}

/**
 * Human-readable route row / summary status (e.g. in_progress → IN Progress).
 */
export function formatRouteStatusLabel(raw) {
  const key = String(raw || "").trim();
  if (!key) return "";
  if (ROUTE_STATUS_LABELS[key]) return ROUTE_STATUS_LABELS[key];
  return key
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}
